import { render, staticRenderFns } from "./StartMutedPolicySettings.vue?vue&type=template&id=eed07cec&scoped=true"
import script from "./StartMutedPolicySettings.vue?vue&type=script&lang=js"
export * from "./StartMutedPolicySettings.vue?vue&type=script&lang=js"
import style0 from "./StartMutedPolicySettings.vue?vue&type=style&index=0&id=eed07cec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed07cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eed07cec')) {
      api.createRecord('eed07cec', component.options)
    } else {
      api.reload('eed07cec', component.options)
    }
    module.hot.accept("./StartMutedPolicySettings.vue?vue&type=template&id=eed07cec&scoped=true", function () {
      api.rerender('eed07cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/StartMutedPolicySettings.vue"
export default component.exports